import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { getCheapestSelectedPackageOption } from 'selectors/offerPage/offerPageSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

interface OfferPageRateOptions {
  disabled?: boolean
}

export const useOfferPageRate = (state: OfferPageState, { disabled = false }: OfferPageRateOptions = {}): App.OfferPackageOptionView | undefined => {
  const packageView: App.OfferPackageOptionView | undefined = useAppSelector(
    (appState) => !disabled ? getCheapestSelectedPackageOption(appState, state) : undefined,
  )
  if (!packageView) return

  return {
    ...packageView,
    hotelPrice: packageView.hotelPrice + (packageView.propertyFees ?? 0),
  }
}
